/**
 * Shoulder posture asymmetric picker — two Selects (Left + Right) using the
 * hardcoded `SHOULDER_POSTURE_ADJUSTMENTS` array as options. Mirrors the
 * `ShoulderPadPair` component's API.
 */
import { Button } from "@/components/ui/button";
import { Link2 } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export default function ShoulderPosturePair({
  styling,
  setStyling,
  options,
  testId = "shoulder-posture",
}) {
  const left = styling?.shoulder_posture_left || "";
  const right = styling?.shoulder_posture_right || "";

  const Picker = ({ label, value, onChange, side }) => (
    <div>
      <label className="text-xs text-slate-400 block mb-1">{label}</label>
      <Select value={value || undefined} onValueChange={onChange}>
        <SelectTrigger
          className="bg-[#0a1628] border-white/10 h-8 text-xs"
          data-testid={`${testId}-${side}-trigger`}
        >
          <SelectValue placeholder="—" />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => (
            <SelectItem key={o} value={o} className="text-xs">
              {o}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );

  return (
    <>
      <Picker
        label="Shoulder Posture (L)"
        value={left}
        onChange={(v) => setStyling({ ...styling, shoulder_posture_left: v })}
        side="left"
      />
      <div className="relative">
        <Picker
          label="Shoulder Posture (R)"
          value={right}
          onChange={(v) => setStyling({ ...styling, shoulder_posture_right: v })}
          side="right"
        />
        <Button
          type="button"
          size="sm"
          onClick={() => left && setStyling({ ...styling, shoulder_posture_right: left })}
          disabled={!left}
          title="Copy Left → Right"
          className="absolute -top-1 right-0 h-5 px-1.5 text-[9px] bg-purple-600 hover:bg-purple-700 text-white disabled:opacity-30"
          data-testid={`${testId}-match-btn`}
        >
          <Link2 size={9} className="mr-0.5" /> Match L→R
        </Button>
      </div>
    </>
  );
}
